import { useNavigate } from 'react-router-dom';

interface IProps {
  icon: string;
  title: string;
  text: string;
  routeToNavigate: string;
}

const HomeCards = ({ icon, title, text, routeToNavigate }: IProps) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(routeToNavigate)}
      className="p-[16px] h-[202px] bg-grey rounded-2xl flex items-center flex-col border border-primitiveGrey cursor-pointer md:m-0 md:h-[140px]"
    >
      <div className="flex h-1/3 mt-5 md:mt-3 items-center justify-center">
        <div className="flex items-center justify-center border border-primitiveBlue h-16 w-16 md:w-[60px] md:h-[60px] rounded-full bg-primitiveBlue">
          <img
            className="opacity-100 md:w-[20px] md:h-[20px]"
            src={icon}
            alt="icon"
          />
        </div>
      </div>
      <div className="flex items-center text-center mt-3 md:mt-4 flex-col">
        <div className={'text-xl font-bold md:text-base'}>{title}</div>
        <div
          className={`${
            text?.length > 30 ? 'text-sm' : 'text-base'
          } 	text-secondaryText mt-1 md:hidden`}
        >
          {text}
        </div>
      </div>
    </div>
  );
};

export default HomeCards;
